import React, { PropsWithChildren, useState } from 'react';
import { Trans } from 'react-i18next';
import { DisplayH3 } from '@components/Text/HeadingTagDisplay.style';
import { StyledGridContainer } from '@components/Grid/Grid.style';
import { Layout, NormalCard, CardTextBox } from '@pages/Main/Home/components/Product/Product.style';
import { ShowMoreButton } from '@pages/CommonStyle/commonBtn';
import { HeadingH3 } from '@components/Text/Heading/Heading.style';
import { ParagraphColor, Spacing } from '@pages/CommonStyle/common.style';
import { IndexBtn, IndexBtnBox } from './Product.style';
import solutionProduct from '@src/lang/ko/enterprise/solutionProduct';
import simple from '@src/lang/ko/simple';
import { IconChevronRightBlack } from '@assets/images/icon';
import i18n from '@pages/i18n';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';
import { DivAllCenter } from '@pages/CommonStyle/commonDiv.style';
import styled from '@emotion/styled';

interface ModalDefaultType {
  pageName: string;
  path: any;
}

const FadeWrapper = styled.div<{ fade: boolean }>`
  transition: opacity 0.3s ease;
  opacity: ${({ fade }) => (fade ? 1 : 0)};
`;

const Product: React.FC<PropsWithChildren<ModalDefaultType>> = ({ pageName, path }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const itemsPerPage = 3;
  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);

  const handleNext = () => {
    setFade(false);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + itemsPerPage) % productCount);
      setFade(true);
    }, 150);
  };

  const handlePrev = () => {
    setFade(false);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - itemsPerPage + productCount) % productCount);
      setFade(true);
    }, 150);
  };

  const solutionProductGroups: Record<string, string[]> = {
    digitaltwin: ['uwbEnterprise', 'orbroOs', 'iiot'],
    constructionSafety: ['uwbEnterprise', 'orbroOs', 'iiot'],
    construction: ['uwbEnterprise', 'orbroOs', 'iiot', 'uwbEnterprise', 'bleEnterprise', 'aiServer', 'uwbStarter', 'uwbEnterprise', 'iiot'],
    logistics: ['bleStarter', 'bleEnterprise', 'aoaEnterprise', 'rtls', 'access', 'iiot'],
    medical: ['uwbEnterprise', 'orbroOs', 'iiot'],
    manufacturing: ['uwbEnterprise', 'orbroOs', 'iiot', 'rtls', 'uwbStarter', 'uwbEnterprise'],
    office: ['bleStarter', 'bleEnterprise', 'aoaEnterprise'],
    retail: ['uwbStarter', 'uwbEnterprise', 'aoaEnterprise'],
    city: ['uwbEnterprise', 'iiot', 'comfortKit', 'uwbEnterprise', 'bleEnterprise', 'aiServer', 'uwbStarter', 'uwbEnterprise', 'iiot'],
  };

  // 1) 키워드 찾기
  const keyword =
    Object.keys(solutionProductGroups).find((key) => pageName.toLowerCase() === key) ||
    Object.keys(solutionProductGroups).find((key) => pageName.toLowerCase().includes(key));

  // 2) 타입 그룹의 순서와 중복을 그대로 살려서 카드 추출
  const cardsForPage = keyword
    ? solutionProductGroups[keyword]
        .map((type) => {
          const idx = solutionProduct.cards.findIndex((card) => card.type === type);
          if (idx === -1) {
            console.warn(`❗️ 카드 타입 매칭 실패: ${type}`);
            return null;
          }
          return { ...solutionProduct.cards[idx], originalIndex: idx }; // originalIndex 보존
        })
        .filter(Boolean)
    : [];

  const productCount = cardsForPage.length;
  const visibleCards = Array.from({ length: itemsPerPage }, (_, i) => {
    const idx = (currentIndex + i) % productCount;
    return cardsForPage[idx];
  });

  return (
    <StyledGridContainer>
      <Spacing pixel="64" />

      <DisplayH3 size="small">
        <Trans i18nKey="solutionProduct.recommand" />
      </DisplayH3>
      <Spacing pixel="32" />

      <FadeWrapper fade={fade}>
        <Layout columns={3}>
          {visibleCards.map((data, i) => (
            <NormalCard key={i} img={data?.img[layoutType]}>
              <CardTextBox>
                <HeadingH3 size="small">
                  <Trans i18nKey={`solutionProduct.cards.${data?.originalIndex}.title`} />
                </HeadingH3>
                <Spacing pixel="4" />
                <ParagraphColor color="#646464" size="small">
                  <Trans i18nKey={`solutionProduct.cards.${data?.originalIndex}.desc`} />
                </ParagraphColor>
                <Spacing pixel="16" />
                <ShowMoreButton href={i18n.language === 'ko' ? `${data?.link}` : `/${i18n.language}${data?.link}`} rel="noopener noreferrer">
                  <img src={simple.showmoreImg[i18n.language]} alt="learn more button" />
                </ShowMoreButton>
              </CardTextBox>
            </NormalCard>
          ))}
        </Layout>
      </FadeWrapper>

      {/* <Spacing pixel="32" />
      <DivAllCenter>
        <IndexBtnBox>
          <IndexBtn onClick={handlePrev} src={IconChevronRightBlack} alt="prev" direction={true} />
          <IndexBtn onClick={handleNext} src={IconChevronRightBlack} alt="next" direction={false} />
        </IndexBtnBox>
      </DivAllCenter> */}
      <Spacing pixel="96" />
    </StyledGridContainer>
  );
};

export default Product;
